import { ADMIN_ROLES } from '../utils/roleHelpers';
/* ── Pre-Onboarding-Constants ── */
export const CREATE_PRE_ONBOARDING_TEXT = {
  pageTitleEdit: 'Edit Candidate',
  pageTitleCreate: 'Add Candidate',
  pageSubtitleEdit: 'Update candidate details',
  pageSubtitleCreate: 'Create a new pre-onboarding record and send invite link',
  backButton: 'Back to Pre-Onboarding',

  firstNameLabel: 'First Name',
  firstNamePlaceholder: 'Enter first name',
  lastNameLabel: 'Last Name',
  lastNamePlaceholder: 'Enter last name',
  phoneLabel: 'Phone Number',
  phonePlaceholder: '10-digit mobile number',
  emailLabel: 'Email ID',
  emailPlaceholder: 'candidate@example.com',
  employmentTypeLabel: 'Employment Type',
  fresherOption: 'Fresher',
  experiencedOption: 'Experienced',
  customizedOption: 'Employment Details',

  cancelButton: 'Cancel',
  savingButton: 'Saving…',
  saveChangesButton: 'Save Changes',
  createButton: 'Create & Send Link',

  countryFlag: '🇮🇳',
  countryCode: '+91',
} as const;

export const CREATE_PRE_ONBOARDING_ERRORS = {
  firstNameRequired: 'First name is required',
  alphabetsOnly: 'Alphabets only',
  lastNameRequired: 'Last name is required',
  phoneRequired: 'Phone number is required',
  phoneInvalid: '10-digit number required',
  emailRequired: 'Email is required',
  emailInvalid: 'Invalid email format',
  emailExists: 'A candidate with this email already exists',
  employmentTypeRequired: 'Please select employment type',
  loadFailed: 'Failed to load candidate',
  updateSuccess: 'Candidate updated successfully',
  createSuccess: 'Candidate created and pre-onboarding link sent',
  saveFailed: 'Failed to save candidate',
} as const;

/* ── PreOnboardingListPage ── */

export const LIST_PAGE_TEXT = {
  bannerTitle: 'Pre-Onboarding',
  bannerSubtitle: 'Manage candidate pre-onboarding records and track document submissions',

  candidatesHeading: 'Candidates',
  addCandidateButton: 'Add Candidate',

  searchPlaceholder: 'Search by name or email…',
  allStatusesPlaceholder: 'All Statuses',
  filterNotCompleted: 'Not Completed',
  filterCompleted: 'Completed',
  filterWithdrawn: 'Withdrawn',

  colName: 'Name',
  colPhone: 'Phone',
  colEmail: 'Email',
  colStatus: 'Status',
  colCreated: 'Created',
  colActions: 'Actions',
  noResultsLabel: 'No candidates found.',

  viewDetailsAction: 'View Details',
  editAction: 'Edit',
  resendLinkAction: 'Resend Pre-Onboarding Link',
  copyLinkAction: 'Copy Link',
  withdrawAction: 'Withdraw',
  moveToOnboardingAction: 'Move to Onboarding',

  withdrawModalTitle: 'Withdraw Candidate',
  withdrawModalMessage:
    'Are you sure you want to withdraw this candidate? Their pre-onboarding link will become inactive.',
  withdrawModalConfirm: 'Withdraw',

  moveSuccessToast: 'Candidate moved to onboarding',
  moveFailToast: 'Failed to move candidate to onboarding',
  resendSuccessToast: 'Pre-onboarding link resent',
  resendFailToast: 'Failed to resend link',
  copySuccessToast: 'Link copied to clipboard',
  copyFailToast: 'Failed to copy link',
  withdrawSuccessToast: 'Candidate withdrawn',
  withdrawFailToast: 'Failed to withdraw candidate',
} as const;

/* ── PreOnboardingReportsPage ── */
export const STATUS_LABELS: Record<string, string> = {
  invited: 'Invited',
  not_completed: 'Not Completed',
  completed: 'Completed',
  withdrawn: 'Withdrawn',
  resubmission: 'Resubmission',
  resubmission_completed: 'Resubmitted',
  moved_to_onboarding: 'Moved to Onboarding',
};

export const REPORTS_TEXT = {
  bannerTitle: 'Pre-Onboarding Reports',
  bannerSubtitle: 'Track candidate status, withdrawals, and pending documents',

  searchPlaceholder: 'Search by name or email…',
  allStatusesOption: 'All Statuses',

  countInvited: 'Invited',
  countNotCompleted: 'Not Completed',
  countCompleted: 'Completed',
  countWithdrawn: 'Withdrawn',
  countResubmission: 'Resubmission',
  countResubmitted: 'Resubmitted',
  countMovedToOnboarding: 'Moved to Onboarding',
  countTotal: 'Total',

  colName: 'Name',
  colEmail: 'Email',
  colPhone: 'Phone',
  colStatus: 'Status',
  colCreated: 'Created',

  loadingLabel: 'Loading…',
  noResultsLabel: 'No candidates found.',
  previousLabel: 'Previous',
  nextLabel: 'Next',
} as const;

/* ── PreOnboardingViewPage ── */

export const VIEW_PAGE_TEXT = {
  loadingBannerTitle: 'Loading…',
  loadingBody: 'Loading candidate…',
  notFoundBannerTitle: 'Not Found',
  notFoundBody: 'Candidate not found.',

  backButton: 'Back',
  pageTitle: 'Candidate Details',
  editAction: 'Edit',
  resendLinkAction: 'Resend Preboarding Link',
  copyLinkAction: 'Copy Link',
  copiedLabel: 'Copied!',
  withdrawAction: 'Withdraw',
  validateAction: 'Validate',
  cancelReviewAction: 'Cancel Review',
  resubmitAction: 'Resubmit',
  sendingLabel: 'Sending…',
  moveToOnboardingAction: 'Move to Onboarding',
  showToAction: 'Share to',

  fresherLabel: 'Fresher',
  experiencedLabel: 'Experienced',
  resubmissionRoundsLabel: 'Resubmission rounds',

  candidateDetailsHeading: 'Candidate Details',
  firstNameLabel: 'First Name',
  lastNameLabel: 'Last Name',
  phoneLabel: 'Phone Number',
  emailLabel: 'Email ID',
  createdAtLabel: 'Created At',
  linkExpiresLabel: 'Link Expires',

  documentsHeading: 'Pre-Onboarding Details',
  submittedLabel: 'Submitted:',
  fieldColumnLabel: 'Field',
  valueColumnLabel: 'Value',
  reasonPlaceholder: 'Reason for rejection (required)',
  cancelRejectionTitle: 'Cancel rejection',
  rejectDocumentTitle: 'Reject this document',
  notUploadedLabel: 'Not uploaded',
  notProvidedLabel: 'Not provided',
  footerNote: 'HR can view and download all attachments.',
  noDocumentsMessage: 'Candidate has not submitted pre-onboarding documents yet.',

  aadhaarNumberField: 'Aadhaar Number',
  aadhaarAttachmentField: 'Aadhaar Attachment',
  panNumberField: 'PAN Number',
  panAttachmentField: 'PAN Attachment',
  payslipField: 'Last 3 months Payslips',
  offerLetterField: 'Current Organization Offer',
  resumeField: 'Resume',
  currentOrgNameField: 'Current Organization Name',
  appraisalLetterField: 'Latest Appraisal Letter',
  relievingLetterField: 'Relieving Letter / Experience Letter',
  employmentAdditionalDocumentField: 'Employment Additional Documents',
  highestQualificationField: 'Highest Qualification',
  degreesField: 'Degree',
  educationalAdditionalDocumentField: 'Degree/Provisional Certificate',
  photographField: 'Passport-size Photograph',

  viewButton: 'View',
  openingButton: 'Opening…',
  downloadButton: 'Download',
  downloadingButton: 'Downloading…',
  openFileFailed: 'Failed to open file',
  downloadFileFailed: 'Failed to download file',

  withdrawModalTitle: 'Withdraw Candidate',
  withdrawModalMessage:
    'Are you sure you want to withdraw this candidate? Their pre-onboarding link will become inactive.',
  withdrawModalConfirm: 'Withdraw',

  loadFailedToast: 'Failed to load candidate',
  withdrawSuccessToast: 'Candidate withdrawn',
  withdrawFailToast: 'Failed to withdraw candidate',
  moveSuccessToast: 'Candidate moved to onboarding',
  moveFailToast: 'Failed to move candidate to onboarding',
  copyLinkFailToast: 'Failed to copy link',
  resendSuccessToast: 'Pre-onboarding link resent',
  resendFailFallback: 'Failed to resend link',
  reasonRequiredToast: 'Please enter a reason for every rejected document',
  rejectSuccessToast: 'Candidate notified to resubmit documents',
  rejectFailFallback: 'Failed to reject documents',
} as const;

/* ── CandidatePreOnboardingPage ── */
export const PRE_ONBOARDING_TEXT = {
  pageTitle: 'Pre-Onboarding Form',
  companyBadge: 'PeopleSuite',
  greetingSuffix: ', please fill in the details below to complete your pre-onboarding.',

  documentsHeading: 'Pre-Onboarding Required Documents',

  employmentHeading: 'Employment',
  educationalHeading: 'Educational',
  photographHeading: 'Passport-size Photograph',
  resumeLabel: 'Resume',

  aadhaarLabel: 'Aadhaar Card',
  aadhaarPlaceholder: '12-digit Aadhaar number',

  panLabel: 'PAN Card',
  panPlaceholder: 'ABCDE1234F',

  payslipLabel: 'Last 3 months Payslips',
  payslipSubtext: 'Upload your recent payslip(s) (PDF only)',
  addMoreButton: 'Add More',

  offerLetterLabel: 'Documents(optional)',

  submitButton: 'Submit Pre-Onboarding',
  submittingButton: 'Submitting…',

  loadingMessage: 'Loading…',

  invalidLinkTitle: 'Invalid or Expired Link',
  invalidLinkMessage:
    'This pre-onboarding link is invalid, expired, or has been withdrawn. Please contact HR for a new link.',

  successTitle: 'Pre-Onboarding Complete!',
  successPrefix: 'Thank you, ',
  successSuffix:
    '! Your pre-onboarding documents have been submitted successfully. HR will review them and get back to you shortly.',

  genericSubmitError: 'Submission failed. Please try again.',
  fileTooLargeError: 'File too large. Maximum size is 10 MB.',
  invalidFileTypeError: 'Only PDF, JPG and PNG files are allowed.',
  invalidFileTypePdfError: 'Only PDF files are allowed.',

  resubmissionBannerTitle: 'HR requested changes to your pre-onboarding submission:',
  resubmissionBannerNote:
    'Please re-upload only the documents listed above; all other details are locked.',
  alreadySubmittedLabel: 'Already submitted',
  resubmissionSuccessTitle: 'Documents Resubmitted!',
  resubmissionSuccessMessagePrefix: 'Thank you, ',
  resubmissionSuccessMessageSuffix:
    '! Your updated documents have been submitted successfully. HR will review them and get back to you shortly.',
  resubmitButton: 'Resubmit Documents',
  resubmittingButton: 'Resubmitting…',
  uploadFilePdfJpgLabel: 'Upload file (PDF/JPG, 10MB)',
  uploadFilePdfLabel: 'Upload file (PDF, 10MB)',
  clickToUploadPdfJpgLabel: 'Click to upload (PDF,JPG or PNG max 10MB)',
  clickToUploadPdfOnlyLabel: 'Click to upload (PDF only, max 10MB)',
} as const;

export const PRE_ONBOARDING_ERRORS = {
  employmentTypeRequired: 'Please select your employment type',
  aadhaarRequired: 'Aadhaar number is required',
  aadhaarInvalid: 'Must be 12 digits',
  panRequired: 'PAN number is required',
  panInvalid: 'Format: ABCDE1234F',
  aadhaarAttachmentRequired: 'Aadhaar attachment is required',
  panAttachmentRequired: 'PAN attachment is required',
} as const;

export const REJECTED_FIELD_LABELS: Record<string, string> = {
  aadhaarAttachmentUrl: 'Aadhaar Attachment',
  panAttachmentUrl: 'PAN Attachment',
  offerLetterUrls: 'Offer Letter',
  relievingLetterUrl: 'Relieving Letter / Experience Letter',
  resumeUrl: 'Resume',
  appraisalLetterUrl: 'Latest Appraisal Letter',
  photographUrl: 'Passport-size Photograph',
  highestQualification: 'Highest Qualification',
  degrees: 'Degree',
};

/* ── Pre-Onboarding Sidebar Nav Items ── */
export const NAV_PRE_ONBOARDING = {
  label: 'Pre-Onboarding',
  icon: 'assignment_ind',
  path: '/pre-onboarding',
  roles: ADMIN_ROLES,
  departments: ['HR', 'Talent Acquisition'] as string[],
} as const;

export const NAV_PRE_ONBOARDING_REPORTS = {
  label: 'Pre-Onboarding Reports',
  icon: 'fact_check',
  path: '/reports/preonboarding',
  roles: ADMIN_ROLES,
  departments: ['HR', 'Talent Acquisition'] as string[],
} as const;
